import base from '~base';

import processInclude from '../util';
import { onEvent } from '../util/domutils';
import { loadContent } from '../util/fetchutils';
import { persistRecommendations, restoreRecommendations } from '../components/recommendations';
import { EVENTS as WISHLIST_EVENTS } from '../product/wishlist';

export const CONSTANTS = {
  MODIFY_TYPES: {
    WISHLIST: 'WISHLIST',
  },
};

export const CLASSES = {
  HIDDEN: 'd-none',
  MODIFIERS: {
    [CONSTANTS.MODIFY_TYPES.WISHLIST]: 'product-card__modifier--wishlist',
  },
  MODIFY_OVERLAYS: {
    [CONSTANTS.MODIFY_TYPES.WISHLIST]: 'product-card__modify-overlay--wishlist',
  },
};

export const SELECTORS = {
  MODIFY_OVERLAYS: {
    [CONSTANTS.MODIFY_TYPES.WISHLIST]: `.${CLASSES.MODIFY_OVERLAYS.WISHLIST}`,
  },
  TILES_CAROUSEL: '.wishlist__products',
  TILES_CAROUSEL_HEADING: '.wishlist__products__heading',
  TILES_CAROUSEL_PRODUCT: '.product',
  WISHLIST_TILE: '.wishlist__products .product-tile',
  get WISHLIST_TILE_ADD() { return `${this.WISHLIST_TILE} .add-to-cart`; },
  get WISHLIST_TILE_TOGGLE() { return `${this.WISHLIST_TILE} .product-tile__wishlist--link.active`; },
};

export const EVENTS = {
  BEFORE_ITEMS_RELOAD: 'cart:before-reload',
  ITEMS_RELOAD: 'cart:reload',
  ITEM_MODIFICATION: 'cart:modify',
};

const handleRecommendationsHeading = () => {
  const carousels = document.querySelectorAll(SELECTORS.TILES_CAROUSEL);

  carousels.forEach((carousel) => {
    const carouselHeading = carousel.querySelector(SELECTORS.TILES_CAROUSEL_HEADING);

    if (carouselHeading) {
      const products = carousel.querySelectorAll(SELECTORS.TILES_CAROUSEL_PRODUCT);

      if (products.length > 0) {
        carouselHeading.classList.remove(CLASSES.HIDDEN);
      }
    }
  });
};

const moveToWishlist = async (trigger) => {
  const { pid } = trigger.dataset;
  const { content } = await loadContent(trigger, null, { pid, source: 'cart' });

  if (content.trim().length) {
    document.querySelector('.cart-container').outerHTML = content;

    document.dispatchEvent(new CustomEvent(EVENTS.ITEMS_RELOAD));
    document.dispatchEvent(new CustomEvent(WISHLIST_EVENTS.WISHLIST_ADD));
    document.dispatchEvent(new CustomEvent('lazy-load-force-update'));
  }
};

export default {
  CONSTANTS,
  CLASSES,
  SELECTORS,
  EVENTS,
  init() {
    processInclude(base);

    handleRecommendationsHeading();

    document.addEventListener('product:carousel-init', handleRecommendationsHeading);
    document.addEventListener(EVENTS.BEFORE_ITEMS_RELOAD, persistRecommendations);
    document.addEventListener(EVENTS.ITEMS_RELOAD, () => {
      handleRecommendationsHeading();
      restoreRecommendations(handleRecommendationsHeading);
    });

    document.addEventListener(EVENTS.ITEM_MODIFICATION, (e) => {
      if (e.detail && e.detail.type === CONSTANTS.MODIFY_TYPES.WISHLIST) {
        moveToWishlist(e.detail.trigger);
      }
    });

    onEvent(document, 'click', SELECTORS.WISHLIST_TILE_ADD, (e) => {
      const tile = e.delegateTarget.closest(SELECTORS.WISHLIST_TILE);
      const wishlistToggle = tile && tile.querySelector(SELECTORS.WISHLIST_TILE_TOGGLE);

      if (wishlistToggle) {
        wishlistToggle.click();
      }
    });
  },
};
